import Swiper from "swiper"
import { find } from "utils/dom"
import gsap from "gsap"
import { ScrollTrigger } from "gsap/ScrollTrigger";


export default function () {
	const Sections = find("[js-page='ds-sections']")
	if (!Sections) return
	console.log("Page DS Sections");
}